import { FunctionComponent } from "react";
import { MessageBar, MessageBarType, Stack, Text } from "@bps/fluent-ui";
import { TenantDefaultUsersAuthenticationDto } from "@libs/api/gateways/plt/plt-gateway.dtos";
import {
  MFA_METHODS_COUNT_MAP,
  TENANT_AUTH_HINT
} from "./user-auth-form.types";
import { MFA_METHODS_OPTIONS_MAP } from "../../../_shared-blocks";

interface TenantAuthMfaHintProps {
  tenantAuth: TenantDefaultUsersAuthenticationDto | undefined;
}
export const TenantAuthMfaHint: FunctionComponent<TenantAuthMfaHintProps> = ({
  tenantAuth
}) => {
  if (typeof tenantAuth?.mfaMethodCount === "undefined") return null;

  const tenantMfaCountText = `${TENANT_AUTH_HINT} ${
    MFA_METHODS_COUNT_MAP[tenantAuth.mfaMethodCount]
  }`;

  return (
    <MessageBar messageBarType={MessageBarType.info}>
      <Stack tokens={{ childrenGap: 4 }}>
        <Text styles={{ root: { fontSize: 12 } }}>{tenantMfaCountText}</Text>
        {tenantAuth?.mfaFirstOptions?.length && (
          <Text
            styles={{ root: { fontSize: 12 } }}
          >{`- MFA Step 1 Config: ${tenantAuth?.mfaFirstOptions
            .map(o => MFA_METHODS_OPTIONS_MAP[o])
            .join(" → ")}`}</Text>
        )}

        {tenantAuth?.mfaSecondOptions?.length && (
          <Text
            styles={{ root: { fontSize: 12 } }}
          >{`- MFA Step 2 Config: ${tenantAuth?.mfaSecondOptions
            .map(o => MFA_METHODS_OPTIONS_MAP[o])
            .join(" → ")}`}</Text>
        )}
      </Stack>
    </MessageBar>
  );
};
